import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useFullscreenTarget } from '@/composables/useFullscreenTarget'
import useQueryEncoder from '@/composables/useQueryEncoder'
import {
  addOpenClientDetailPanelListener,
  removeOpenClientDetailPanelListener,
  type OpenClientDetailPanelInput,
} from '@/components/GraphqlDataTable/listners'

export const CLIENT_ID_KEY = 'client-id'

/** A clients table's drawer, driven by ?client-id= so Back, Forward and deep links all reach it. */
export function useClientDrawer() {
  const drawerTarget = useFullscreenTarget()
  const encodedClientId = useQueryEncoder(CLIENT_ID_KEY, null)

  // The drawer stays mounted so WdsDrawer can animate; the last id survives the leave transition.
  const drawerClientId = ref<string | null>(encodedClientId.value ?? null)
  const showDrawer = ref(!!encodedClientId.value)

  watch(
    encodedClientId,
    (clientId) => {
      if (clientId) drawerClientId.value = clientId
      showDrawer.value = !!clientId
    },
    { flush: 'sync' },
  )

  const openDrawer = (input: OpenClientDetailPanelInput) => {
    encodedClientId.value = input.clientRelationId
  }

  onMounted(() => addOpenClientDetailPanelListener(openDrawer))
  onBeforeUnmount(() => removeOpenClientDetailPanelListener(openDrawer))

  function onDrawerToggle(show: boolean) {
    showDrawer.value = show
    if (!show) {
      encodedClientId.value = null
    }
  }

  return { drawerTarget, drawerClientId, showDrawer, onDrawerToggle }
}
